import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UsersUserSideMenuService {
    private setSideMenuIsOpenSubject = new Subject<boolean>();
    public setSideMenuIsOpenAction$ = this.setSideMenuIsOpenSubject.asObservable();

    public openSideMenu(): void {
        this.setSideMenuIsOpenSubject.next(true);
    }
}
